import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  doc_no: string;
  process_date: string | null;
  vendor_code: string;
  subcontract_name: string;
  status: string;
  default_checked: boolean;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ReverseResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ReverseResponse {
  results: ReverseResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ReversalFilter {
  docStart: string;
  docEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const j5n5Api = {
  // GET /api/j5n5/pending?docStart=&docEnd=
  async getPending(filter: ReversalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/j5n5/pending', {
      params: {
        docStart: filter.docStart,
        docEnd: filter.docEnd,
      },
    });
    return res.data;
  },

  // POST /api/j5n5/reverse
  async reverse(docNos: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/j5n5/reverse', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
